// extracted by mini-css-extract-plugin
export default {"afterpayBtnWrapper":"e--z","button":"f--z","disabled":"g--z","creditCard":"h--z","wrapper":"i--z"};